import React from "react";
import AiSummaryWidget from "../../ai-summary/AiSummaryWidget";
const defaultAlt = "Delhi Airport - Indira Gandhi International Airport - Hero Banner";
const NewStyleBanner = ({
  banner_section,
  mobileImageFit = "cover",
  mobileImageSource = "mobile",
  mobileHeadingPlacement = "default",
  renderAiSummary = true
}) => {
  const altText =
    banner_section?.mobile_bg?.alternativeText ||
    banner_section?.desktop_bg?.alternativeText ||
    banner_section?.heading ||
    defaultAlt;
  const mobileImage =
    mobileImageSource === "desktop"
      ? banner_section?.desktop_bg
      : banner_section?.mobile_bg;
  const imageClassName =
    mobileImageFit === "contain"
      ? "w-full object-contain h-auto min-h-0 lg:object-cover lg:h-[28vw] lg:md:min-h-[28vw]"
      : "w-full object-cover lg:h-[28vw] lg:md:min-h-[28vw] md:min-h-[50vw] h-full";
  const mobileHeadingClassName =
    mobileHeadingPlacement === "right"
      ? "right-[7vw] top-[47%] w-[42%]"
      : "top-[52%] w-full";
  const mobileHeadingInnerClassName =
    mobileHeadingPlacement === "right"
      ? "w-full drop-shadow-lg"
      : "w-[85%] mx-auto drop-shadow-lg";

  return (
    <>
      <div
        role="group"
        aria-roledescription="slide"
        className="relative w-full h-full"
      >
        <picture>
          {/* Desktop Source */}
          <source
            media="(min-width: 1024px)"
            srcSet={`
            ${banner_section?.desktop_bg?.url}?w=768 768w,
            ${banner_section?.desktop_bg?.url}?w=1024 1024w,
            ${banner_section?.desktop_bg?.url}?w=1366 1366w,
            ${banner_section?.desktop_bg?.url}?w=1920 1920w
          `}
            sizes="100vw"
          />
          {/* Mobile Source */}
          <source
            media="(max-width: 1023px)"
            srcSet={`${mobileImage?.url}?format=webp`}
          />
          {/* Fallback & Display Image */}
          <img
            src={`${banner_section?.desktop_bg?.url}?format=webp`}
            alt={altText}
            className={imageClassName}
            loading="eager"
            fetchpriority="high"
            width="1335"
            height="378"
          />
        </picture>

        {/* Desktop Overlay Text */}
        <div className="lg:flex hidden absolute inset-y-0 right-[1vw] items-center lg:w-[45%] pr-[1.7vw] text-white drop-shadow-lg">
          <div>
            {banner_section?.heading && (
              <h1 className="font-redhatBold text-[3.55vw] leading-[4vw] py-[1vw]">
                {banner_section?.heading}
              </h1>
            )}
          </div>
        </div>

        {/* Mobile Overlay Text */}
        <div
          className={`lg:hidden block absolute text-white ${mobileHeadingClassName}`}
        >
          <div className={mobileHeadingInnerClassName}>
            {banner_section?.heading && (
              <h1 className="font-redhatBold text-[6.5vw] leading-tight">
                {banner_section?.heading}
              </h1>
            )}
          </div>
        </div>
      </div>
      {renderAiSummary ? <AiSummaryWidget /> : null}
    </>
  );
};

export default NewStyleBanner;
